import React from 'react';
import {
  BigTab
} from "appStyles";

function ChoosePlan({
  plan,
  setPlan
}){
  const tabBorder = (currPlan) => {
    const border = plan === currPlan ? '3px solid #89D2D3' : 'none';
    return border;
  };

  return (
    <div
      style={{
        padding: '40px'
      }}
    >
      <h2>Choose your plan</h2>
      <div 
        className={BigTab}
        onClick={() => setPlan('starter')}
        style={{
          border: tabBorder('starter')
        }}
      >
        <h2>Starter</h2>
        <p>- Up to 20 app downloads</p>
        <p
          style={{
            marginLeft: 'auto'
          }}
        >FREE</p>
      </div>
      <div 
        className={BigTab}
        onClick={() => setPlan('plus')}
        style={{
          border: tabBorder('plus')
        }}        
      >
        <h2>Plus</h2>
        <p>- Up to 20 app downloads</p>
        <div
          style={{
            marginLeft: 'auto'
          }}          
        >
          <h3>$19.99/month</h3>
          <p>charged only when you reach 20+ app downloads</p>
        </div>
      </div>
    </div>
  );
}

export default ChoosePlan;